import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const languageSettingsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.languageSettings.route,
      lazy: () => import("@pages/panelPages/languageSetting/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.language", [], "index");
        return {};
      },
    },
    permissions: [
      "patient",
      "doctor",
      "staff",
      "super-admin",
      "local-admin",
      "admin",
      "inactive-patient",
      "medical-service-provider-drug",
      "medical-service-provider-lab",
      "medical-service-provider-image",
    ],
  },
];
